// 测试环境 AI前缀
export const environment = {
    production: false,
    isSpecialDeploy: false
}